import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function SwitchCameraIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 54 54" fill="none">
      <rect width="54" height="54" rx="24" fill="#4E7FFF" />
      <path
        fill="none"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 24V33C36 34.105 35.105 35 34 35H20C18.895 35 18 34.105 18 33V24C18 22.895 18.895 22 20 22H22L23.462 19.496C23.641 19.189 23.97 19 24.326 19H29.63C29.981 19 30.306 19.184 30.487 19.484L32 22H34C35.105 22 36 22.895 36 24Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.4 31.4594C29.45 32.351 28.3167 32.7969 27 32.7969C26.5833 32.7969 26.1792 32.7385 25.7875 32.6219C25.3958 32.5052 25.0167 32.3469 24.65 32.1469L25.75 31.0469C25.95 31.1302 26.1542 31.1927 26.3625 31.2344C26.5708 31.276 26.7833 31.2969 27 31.2969C27.9 31.2969 28.675 31.001 29.325 30.4094C29.975 29.8177 30.35 29.0802 30.45 28.1969L29.8 28.8469L28.75 27.7969L31.25 25.2969L33.75 27.7969L32.7 28.8469L31.95 28.1469C31.8667 29.4635 31.35 30.5677 30.4 31.4594Z"
        fill="white"
      />
      <path
        d="M25.25 27.7969L22.75 30.2969L20.25 27.7969L21.3 26.7469L22.05 27.4469C22.1333 26.1302 22.65 25.026 23.6 24.1344C24.55 23.2427 25.6833 22.7969 27 22.7969C27.4167 22.7969 27.8208 22.8552 28.2125 22.9719C28.6042 23.0885 28.9833 23.2469 29.35 23.4469L28.25 24.5469C28.05 24.4635 27.8458 24.401 27.6375 24.3594C27.4292 24.3177 27.2167 24.2969 27 24.2969C26.1 24.2969 25.325 24.5927 24.675 25.1844C24.025 25.776 23.65 26.5135 23.55 27.3969L24.2 26.7469L25.25 27.7969Z"
        fill="white"
      />
    </SvgIcon>
  );
}
